/**
 * @file SendResetMailPasswordForm.tsx
 * @description
 * -----------------------------------------------------
 * Component de Resetear contraseña
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-01-15
 * @modified 2025-07-17
 * @author DLTCode
 * @author Sergio Manjón
 * @author Ismael Benabdellah
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { startTransition, useState } from "react";
import { useTranslations } from "next-intl";
import InputComponent from "@/components/ui/InputComponent";
import ButtonComponent from "@/components/ui/ButtonComponent";
import { toast } from "sonner";
import { sendResetMail } from "../actions";
type SendResetMailPasswordProps = {
  onSuccess?: () => void;
};
const SendResetMailPassword = t0 => {
  const $ = _c(33);
  const {
    onSuccess
  } = t0;
  const placeholders = useTranslations("Placeholders");
  const labels = useTranslations("Labels");
  const buttons = useTranslations("Buttons");
  const modals = useTranslations("Modals");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mail: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [formData, setFormData] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [errors, setErrors] = useState(t2);
  const [isPending, setIsPending] = useState(false);
  let t3;
  if ($[2] !== errors || $[3] !== formData) {
    t3 = e => {
      const {
        id,
        value
      } = e.target;
      setFormData({
        ...formData,
        [id]: value
      });
      if (errors[id]) {
        setErrors(prevErrors => {
          const newErrors = {
            ...prevErrors
          };
          delete newErrors[id];
          return newErrors;
        });
      }
    };
    $[2] = errors;
    $[3] = formData;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleChange = t3;
  let t4;
  if ($[5] !== onSuccess) {
    t4 = e_0 => {
      e_0.preventDefault();
      const data = new FormData(e_0.target as HTMLFormElement);
      setIsPending(true);
      startTransition(async () => {
        const response = await sendResetMail(data);
        if (response && "fieldErrors" in response) {
          setErrors(response.fieldErrors);
          setIsPending(false);
          return;
        }
        if (response && response.error) {
          toast.error(response.message || response.error);
          setIsPending(false);
          return;
        }
        setIsPending(false);
        onSuccess?.();
      });
    };
    $[5] = onSuccess;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSubmit = t4;
  let t5;
  if ($[7] !== labels) {
    t5 = labels("labelMail");
    $[7] = labels;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== placeholders) {
    t6 = placeholders("placeholderMail");
    $[9] = placeholders;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = errors.mail && errors.mail[0];
  let t8;
  if ($[11] !== formData.mail || $[12] !== handleChange || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <InputComponent id="mail" name="mail" label={t5} type="text" placeholder={t6} value={formData.mail} onChange={handleChange} error={t7} className="input--full" autoComplete="email" isRequired={true} />;
    $[11] = formData.mail;
    $[12] = handleChange;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== modals) {
    t9 = modals("requiredFieldsMessage");
    $[17] = modals;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <p className="auth__required-message">{t9}</p>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== buttons) {
    t11 = buttons("buttonRestore");
    $[21] = buttons;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isPending || $[24] !== t11) {
    t12 = <ButtonComponent type="submit" disabled={isPending} loading={isPending}>{t11}</ButtonComponent>;
    $[23] = isPending;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12) {
    t13 = <section className="send-reset__footer">{t10}{t12}</section>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== handleSubmit || $[30] !== t13 || $[31] !== t8) {
    t14 = <form className="auth__form-base auth__send-reset-form" onSubmit={handleSubmit}>{t8}{t13}</form>;
    $[29] = handleSubmit;
    $[30] = t13;
    $[31] = t8;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default SendResetMailPassword;